import Image from "next/image";
import IMAGES from "../../../../../images/importImages";
import { conditions } from "../../../../../helpers";
import { ConditionName } from "../../../../../interfaces";
import { useAppSelector } from "redux-share";
import { shallowEqual } from 'react-redux'

const SettingsIcon = () => {

    useAppSelector(({ controller: { showMiniPlayer } }) => ({ showMiniPlayer }), shallowEqual);
    useAppSelector(({ videoData: { videoElementSizeInfo, params } }) => ({ videoElementSizeInfo, params }), shallowEqual);

    return (
        <>
            {conditions(ConditionName.isSplusEnvironment) ? (
                <i className={`fa-solid fa-gear pl-cursor-pointer pl-text-white ${conditions(ConditionName.isSpinSettingsIcon) && "pl-animate-spin"} ${conditions(ConditionName.isMiniPlayer) ? "pl-text-[13px]" : "pl-text-[22px]"}`} />
            ) : (
                <Image
                    alt="settings-icon"
                    src={IMAGES.settings}
                    width={conditions(ConditionName.isMiniPlayer) ? 13 : conditions(ConditionName.isComplexPortrait) ? 17 : 22}
                    height={conditions(ConditionName.isMiniPlayer) ? 13 : conditions(ConditionName.isComplexPortrait) ? 17 : 22}
                    className={`${conditions(ConditionName.isSpinSettingsIcon) && "pl-animate-spin"}`}
                />
            )}
        </>
    )
}

export default SettingsIcon;